import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { PrintHeader } from 'js/components/print';

const ReportListPrintHeader = (props) => {
  const { className, heading, ...headerProps } = props;

  return (
    <PrintHeader
      className={classnames('report-list-print-header', className)}
      heading={heading}
      {...headerProps}
    />
  );
};

ReportListPrintHeader.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  heading: PropTypes.string,
};

export default ReportListPrintHeader;
